import { supabase, supabaseConfig } from "./supabase.js";

async function execute(action, data = {}) {
  const { data: response, error } = await supabase.functions.invoke(
    supabaseConfig.adminUsersFunction,
    { body: { action, ...data } }
  );

  if (error) {
    let message = error.message || "A operação administrativa falhou.";
    try {
      const context = await error.context?.json();
      if (context?.message) message = context.message;
    } catch {}
    throw new Error(message);
  }
  if (!response?.ok) {
    throw new Error(response?.message || "A operação administrativa falhou.");
  }
  return response;
}

export async function listResearchers() {
  return (await execute("list_accounts")).accounts || [];
}

export async function createManagedUser(data) {
  return execute("create_user", data);
}

export async function updateManagedUser(userId, data) {
  return execute("update_user", { userId, ...data });
}

export async function setManagedUserStatus(userId, status) {
  return execute("set_status", { userId, status: Boolean(status) });
}

export async function resetManagedUserPassword(userId, password) {
  return execute("reset_password", { userId, password });
}

export async function changeInitialPassword(password) {
  return execute("change_initial_password", { password });
}
